module.exports = __webpack_public_path__ + "static/media/01 Minutes of Meeting 11 April 2023.80cb0877.pdf";